import { GridColumnType } from "../../../data/gridColumnType";

export const XeroPaymentListConfig = {
  columns: [
    {
      name: "Company Name",
      fieldName: "registeredCompanyName",
      allowShort: false,
      colType: GridColumnType.Text,
    },
    {
      name: "Included Certs",
      fieldName: "certificateNmbers",
      colType: GridColumnType.Text,
    },
    {
      name: "Overseas Charge",
      fieldName: "overSeas",
      colType: GridColumnType.Text,
    },
    {
      name: "Invoice Number",
      fieldName: "invoiceNumber",
      colType: GridColumnType.LINK,
      colSettings: {
        isOpenNewTab: true,
        url: "$invoiceLink",
      },
    },
    {
      name: "Invoice Amount",
      fieldName: "totalAmount",
      colType: GridColumnType.Text,
    },
    {
      name: "Payment Date",
      fieldName: "date",
      colType: GridColumnType.Text,
    },
    {
      name: "Status",
      fieldName: "status",
      colType: GridColumnType.Text,
    },
  ],
};
